module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_4.858f89d2.png";